import * as yup from "yup";

const passwordRules = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{5,}$/;
// min 5 characters, 1 upper case letter, 1 lower case letter, 1 numeric digit.

export const basicSchema = yup.object().shape({
  email: yup.string()
  .email("Please enter a valid email")
  .required("Required"),
  username: yup.string()
  .min(5, "Username must be at least 5 characters long")
  .required("Required"),
  newPassword: yup
    .string()
    .min(5)
    .matches(passwordRules, { message: "Password must contain minimum 1 uppercase letter, 1 lowercase letter and 1 digit" })
    .required("Required"),
  newPasswordConfirm: yup
    .string()
    .oneOf([yup.ref("newPassword"), null], "Passwords must match")
    .required("Required"),
});